import { render, staticRenderFns } from "./TasksContent.vue?vue&type=template&id=491cb09c"
import script from "./TasksContent.vue?vue&type=script&lang=js"
export * from "./TasksContent.vue?vue&type=script&lang=js"
import style0 from "./TasksContent.vue?vue&type=style&index=0&id=491cb09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports